export interface Testimonial {
  initials: string
  name: string
  role: string
  text: string
}

export const featuredTestimonials: Testimonial[] = [
  {
    initials: 'SM',
    name: 'S.M.',
    role: 'Mindfulness Teacher — London, UK',
    text: 'I used to spend every Sunday night writing meditation scripts and session structures. Now I open the library, choose the session and walk in completely prepared. My students feel the difference — and so do I.',
  },
  {
    initials: 'CV',
    name: 'C.V.',
    role: 'Meditation Instructor — Toronto, Canada',
    text: 'The cueing and language tools alone were worth the full price. I teach meditation three times a week and every month I would run out of ideas about what to say. Now I have 200+ cues ready for every situation.',
  },
  {
    initials: 'JR',
    name: 'J.R.',
    role: 'Mindfulness Teacher — Sydney, Australia',
    text: 'The troubleshooting library completely changed how I handle difficult groups. My feedback is clearer, my transitions are more professional, and my students actually understand how to practice.',
  },
]

export const extendedTestimonials: Testimonial[] = [
  {
    initials: 'VT',
    name: 'V.T.',
    role: 'Mindfulness Teacher | New York, USA',
    text: 'The body awareness system completely changed how I structure every class. The sessions are already written — I just teach them. My classes feel more professional than ever and my students are developing real grounding.',
  },
  {
    initials: 'CR',
    name: 'C.R.',
    role: 'Meditation Instructor | Melbourne, Australia',
    text: 'The rescue session plans saved me countless times in my first month. I used to get nervous when my original plan fell through. Now I just open the library and teach.',
  },
  {
    initials: 'DG',
    name: 'D.G.',
    role: 'Mindfulness Teacher | Toronto, Canada',
    text: 'I review the cueing and language library before every session and walk in knowing exactly what I will say. The corrections are professional, clear, and my students actually understand how to practice.',
  },
  {
    initials: 'AM',
    name: 'A.M.',
    role: 'Meditation Instructor | London, UK',
    text: 'The troubleshooting tools gave me complete confidence with my difficult groups. Before this, I was always searching for solutions. Now I have 75 rescue options and I know exactly what to do when the group needs something different.',
  },
  {
    initials: 'SR',
    name: 'S.R.',
    role: 'Mindfulness Teacher | Dublin, Ireland',
    text: 'The retreat toolkit was a game-changer. My last retreat was the most organized I have ever facilitated. No forgotten details, no last-minute panic — everything was under control from welcome to closing.',
  },
]
